import React from "react";
import Layout from "../layout/Layout";
import Banner from "../components/termsandconditions/Banner";
import Terms from "../components/termsandconditions/Terms";
const TermsAndConditions = () => {
  return (
    <>
      <Layout>
        <Banner />
        <Terms />
      </Layout>
    </>
  );
};

export default TermsAndConditions;
